/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordSignInRequest
 */
export interface PasswordSignInRequest {
    /**
     * 
     * @type {string}
     * @memberof PasswordSignInRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordSignInRequest
     */
    password: string;
}

export function PasswordSignInRequestFromJSON(json: any): PasswordSignInRequest {
    return PasswordSignInRequestFromJSONTyped(json, false);
}

export function PasswordSignInRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSignInRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function PasswordSignInRequestToJSON(value?: PasswordSignInRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}


